module.exports = __webpack_public_path__ + "img/no-project.9eed07ca.png";